<template>
  <div style="width: 100%;">
    <el-input style="width: calc(100% - 101px);" v-model="customimageName" readonly placeholder="이미지를 선택해주십시오.">
      <div :class="$style['close-btn']" slot="suffix" v-if="customimageName">
        <span @click="onClearClick">
          <i class="fas fa-times-circle" style="cursor: pointer;"></i>
        </span>
      </div>
    </el-input>
    <el-button @click="onSelectClick">
      <i class="far fa-file-image"></i>
      이미지 선택
    </el-button>
  </div>
</template>

<script>
import { MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WImageSelect',
  props: ['value'],
  data() {
    return {
      /**
       * 이미지 아이디
       * @type {Number}
       */
      customimageId: this.value,
    };
  },
  computed: {
    /**
     * 이미지 이름을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    customimageName() {
      return (this.$store.getters.getCustomimage[this.customimageId] && this.$store.getters.getCustomimage[this.customimageId].customimageName) || '';
    },
  },
  watch: {
    value(val) {
      this.customimageId = val;
    },
  },
  methods: {
    /**
     * 이미지 선택 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSelectClick() {
      MapInfo.getInstance(this).getPanel().$refs.imageSelectPopup.$on('imageSelect', this.onImageSelect);
      MapInfo.getInstance(this).getPanel().$refs.imageSelectPopup.open();
    },
    /**
     * 이미지 선택 팝업에서 이미지 선택 후 확인 버튼을 클릭하면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {Object} customimage 선택 한 이미지 정보
     */
    onImageSelect(customimage) {
      MapInfo.getInstance(this).getPanel().$refs.imageSelectPopup.$off('imageSelect', this.onImageSelect);
      this.handleChange((customimage && customimage.customimageId) || -1);
    },
    /**
     * 선택 취소 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onClearClick() {
      this.handleChange(-1);
    },
    /**
     * 선택 된 이미지 아이디 동기화
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    handleChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style module>
.close-btn {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/ImageSelect.vue